import React from "react"
import { getIconSize } from "utils/get-icon-size"

export function Search({
  fill = "white",
  h = 18,
  w = 18,
  className = "",
}: {
  fill?: string
  h?: string | number
  w?: string | number
  className?: string
}) {
  return (
    <svg
      width={w}
      height={h}
      className={`w-[${getIconSize(w)}] h-[${getIconSize(h)}] ${className}`}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7539 15.5637L14.2488 12.0586C14.0906 11.9004 13.8762 11.8125 13.6512 11.8125H13.0781C14.0484 10.5715 14.625 9.01055 14.625 7.3125C14.625 3.27305 11.352 0 7.3125 0C3.27305 0 0 3.27305 0 7.3125C0 11.352 3.27305 14.625 7.3125 14.625C9.01055 14.625 10.5715 14.0484 11.8125 13.0781V13.6512C11.8125 13.8762 11.9004 14.0906 12.0586 14.2488L15.5637 17.7539C15.8941 18.0844 16.4285 18.0844 16.7555 17.7539L17.7504 16.759C18.0809 16.4285 18.0809 15.8941 17.7539 15.5637ZM7.3125 11.8125C4.82695 11.8125 2.8125 9.80156 2.8125 7.3125C2.8125 4.82695 4.82344 2.8125 7.3125 2.8125C9.79805 2.8125 11.8125 4.82344 11.8125 7.3125C11.8125 9.79805 9.80156 11.8125 7.3125 11.8125Z"
        fill={fill}
        fillOpacity="0.4"
      />
    </svg>
  )
}
